/**
 * Diacritic-insensitive text helpers for search / autocomplete filters.
 */

/**
 * Lowercase and strip combining marks (ț→t, ă→a, ș→s, etc.).
 * @param {unknown} value
 * @returns {string}
 */
export function foldDiacritics(value) {
    return String(value ?? '')
        .toLowerCase()
        // Romanian comma-below letters do not always decompose under NFD.
        .replace(/[ăâ]/g, 'a')
        .replace(/î/g, 'i')
        .replace(/[șş]/g, 's')
        .replace(/[țţ]/g, 't')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * @param {unknown} haystack
 * @param {unknown} needle
 * @returns {boolean}
 */
export function includesFolded(haystack, needle) {
    const foldedNeedle = foldDiacritics(needle);
    if (!foldedNeedle) {
        return true;
    }
    return foldDiacritics(haystack).includes(foldedNeedle);
}

/**
 * Vuetify 3 `custom-filter` compatible matcher.
 * @param {string} value
 * @param {string} query
 * @returns {boolean}
 */
export function diacriticInsensitiveFilter(value, query) {
    return includesFolded(value, query);
}
